<template>
  <v-form ref="rideTypeForm" v-model="valid">
    <v-layout style="width: 100%" row wrap>
      <v-flex xs12>
        <h4 class="grey--text text--darken-1">Ride Type</h4>
      </v-flex>
      <v-flex xs6 md2 px-2>
        <v-text-field
          :error-messages="errorForField('name')"
          :rules="rideTypeRules.name"
          v-model="rideType.name"
          label="Name"
          @input="resetError('name')"
        /> </v-flex
      ><v-flex xs6 md2 px-2>
        <v-text-field
          :error-messages="errorForField('alternative_name')"
          :rules="rideTypeRules.alternative_name"
          v-model="rideType.alternative_name"
          label="Alternative Name"
          @input="resetError('alternative_name')"
        />
      </v-flex>
      <v-flex xs6 md4 px-2>
        <v-text-field
          :error-messages="errorForField('description')"
          :rules="rideTypeRules.description"
          v-model="rideType.description"
          label="Description"
          @input="resetError('description')"
        />
      </v-flex>
      <v-flex xs6 md3 px-2>
        <FileInput
          label="Image"
          icon="photo_camera"
          accept="image/*"
          inputRef="imageInput"
          :required="true"
          @fileInput="handleImageInput"
          :errorMessage="errorForField('image')"
          :rules="rideTypeRules.image"
        />
      </v-flex>
      <v-flex xs6 md3 px-2>
        <FileInput
          label="Alternative Image"
          icon="photo_camera"
          accept="image/*"
          inputRef="alternativeImageInput"
          :required="false"
          @fileInput="handleAlternativeImageInput"
          :errorMessage="errorForField('alternative_image')"
          :rules="rideTypeRules.alternative_image"
        />
      </v-flex>
      <v-flex xs6 md3 px-2>
        <v-text-field
          :error-messages="errorForField('num_seats')"
          :rules="rideTypeRules.num_seats"
          v-model="rideType.num_seats"
          prepend-inner-icon="people"
          type="number"
          step="1"
          label="Number of Passengers"
          @input="resetError('num_seats')"
        />
      </v-flex>
      <v-flex xs6 md3 px-2>
        <v-text-field
          :error-messages="errorForField('availability_warning_threshold')"
          :rules="rideTypeRules.availability_warning_threshold"
          v-model="rideType.availability_warning_threshold"
          type="number"
          step="1"
          label="App Availability Warning Threshold (Minutes)"
          @input="resetError('availability_warning_threshold')"
        />
      </v-flex>
      <v-flex xs6 md3 px-2>
        <v-text-field
          :error-messages="errorForField('wait_time')"
          :rules="rideTypeRules.wait_time_period"
          v-model="rideType.wait_time_period"
          type="number"
          step="1"
          label="Waiting Time Kickin Minutes"
          @input="resetError('wait_time_period')"
        />
      </v-flex>
      <v-flex xs3 md2 pl-3 pr-2 pt-2>
        <v-checkbox
          v-model="rideType.disabled_access"
          color="primary"
          label="Disabled Access"
        />
      </v-flex>
      <v-flex xs3 md2 pl-3 pr-2 pt-2>
        <v-checkbox
          v-model="rideType.premium_vehicle"
          color="primary"
          label="Premium Vehicle"
        />
      </v-flex>
      <v-flex xs3 md2 pl-3 pr-2 pt-2>
        <v-switch v-model="rideType.enabled" color="primary" label=" Enabled" />
      </v-flex>
      <v-flex xs3 md3 pl-3 pr-2 pt-2>
        <v-switch
          v-model="rideType.requires_prebooking"
          color="primary"
          label=" Require Prebook (App)"
        />
      </v-flex>
    </v-layout>
  </v-form>
</template>

<script>
import FileInput from "@/components/widget/input/FileInput.vue";

export default {
  name: "ride_type_form",
  components: {
    FileInput,
  },
  props: {
    rideType: Object,
    disabled: Boolean,
    errors: { type: Object, default: () => {} },
  },
  data: function () {
    return {
      valid: false,
      rideTypeRules: {
        name: [
          (v) => !!v || "Name is required",
          (v) => v.length <= 50 || "Name must be less than 200 characters",
        ],
        description: [
          (v) => !!v || "Description is required",
          (v) =>
            v.length <= 200 || "Description must be less than 200 characters",
        ],
        image: [
          (v) => (this.rideType.picture ? true : !!v || "Image is required"),
        ],
        num_seats: [
          (v) => !!v || "Number of passengers is required",
          (v) =>
            (v > 0 && v < 9) || "No. of passengers must be between 1 and 8",
        ],
        availability_threshold: [
          (v) => !!v || "Availability Threshold is required",
          (v) =>
            v >= 0 ||
            "Availability threshold must be a positive number of minutes",
        ], 
        availability_threshold: [
          (v) => !!v || "Waiting time kicking period is required",
          (v) =>
            v >= 0 ||
            "Wait Time Kickin must be a positive number of minutes",
        ],
      },
     
    };
  },
  methods: {
    errorForField: function (field) {
      try {
        return this.errors[field];
      } catch (err) {
        return null;
      }
    },
    resetError: function (field) {
      try {
        if (this.errors[field] != "") {
          this.errors[field] = "";
        }
      } catch (err) {}
    },
    validateForm: function () {
      this.$refs.rideTypeForm.validate();
    },
    handleImageInput: function (file) {
      this.resetError("image");
      this.$emit("imageInput", file);
    },
    handleAlternativeImageInput: function (file) {
      this.resetError("alternative_image");
      this.$emit("alternativeImageInput", file);
    },
  },
  watch: {
    valid: function () {
      this.$emit("validityChange", this.valid);
    },
  },
};
</script>

<style>
.noStepNumber input[type="number"] {
  -moz-appearance: textfield;
}
.noStepNumber input::-webkit-outer-spin-button,
.noStepNumber input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
</style>